/* istanbul ignore file */
export const ACCEPTED_TIME_KEY_SET = [
    ":",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "ArrowLeft",
    "ArrowRight",
    "Backspace",
    "Delete",
    "Shift",
];
export const ERROR_CODE_TIME_CONFLICT = "TMS-TIME-CONFLICT";
export const ERROR_CODE_TIME_EARLIER_THAN_LASTLOG = "TMS-TIME-EARLIER-LASTLOG";
export const FIVE_MINUTES_IN_MILLIS = 300000;
export const ONE_HOUR_IN_MILLIS = 3600000;
export const ONE_MINUTE_IN_MILLIS = 60000;
